import {createRoot} from "react-dom/client";


export const render = (component, containerElementId) => {
  const container = document.getElementById(containerElementId);
  if (!container) {
    throw new Error(`Could not find element with id "${containerElementId}"`);
  }
  const root = createRoot(container);
  root.render(component);
}
